import { render, staticRenderFns } from "./markAsDelivered.vue?vue&type=template&id=be338a08"
import script from "./markAsDelivered.vue?vue&type=script&lang=js"
export * from "./markAsDelivered.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports